<template>
  <div v-loading="loading && !profiles.length" element-loading-text="Loading Profile...">
    <div class="infinite-list-wrapper" style="overflow-y:auto; overflow-x:hidden" infinite-scroll-disabled="disabled">
      <el-row :gutter="6" style="overflow:auto">
        <el-col :span="6" v-for="profile in profiles" :key="profile.id">
          <grid-card style="margin: 12px 0px" :profile="profile" @click.native="showProfile(profile)" />
        </el-col>
      </el-row>
    </div>

    <el-row>
      <el-col :span="24" class="text-center">
        <p class="loading-profile" v-if="loading && !profiles.length">
          <i class="el-icon-loading"></i>
        </p>
      </el-col>
    </el-row>

    <dialog-card
      :initialProfile="profile"
      :visible="showProfileCard"
      @close="handleCloseCard"
      v-if="profile"
    />
  </div>
</template>

<script>
import VirtualList from 'vue-virtual-scroll-list';
import GridCard from '@/components/profiles/profile/GridCard';
import DialogCard from '@/components/permission/profile/DialogCard';

export default {
  name: 'PermissionProfileBrowser',
  data: () => ({
    gridView: true,
    showProfileCard: true,
    profile: null,
  }),
  components: {
    VirtualList,
    GridCard,
    DialogCard,
  },
  methods: {
    handleCloseCard() {
      this.showProfileCard = false;
      this.profile = null;
    },
    showProfile(profile) {
      this.profile = profile;
      this.showProfileCard = true;
    },
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    profiles: {
      type: Array,
      required: true,
    },
    loadingProfile: {
      type: Boolean,
      required: true,
    },
    filteredTotal: {
      type: Number,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.loading-profile {
  font-size: 1.5em;
  padding: 30px 0px;
}
</style>


// WEBPACK FOOTER //
// PermissionProfileBrowser.vue?1fc6ea0f